import { getCurrentYearMonthUnderscored } from './FormatDate';

/**
 * Requested by the Marketing team to add UTM parameters to the ProPlus link
 * @returns
 */
export const getUtmsForProPlus = () => {
   return `?utm_source=website&utm_medium=forecast&utm_campaign=${getCurrentYearMonthUnderscored()}_proplus`;
};
